import React, { useEffect, useRef } from 'react';
import './Hero.css';

export default function Hero() {
  const parallaxRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (parallaxRef.current) {
        const scrollY = window.scrollY;
        parallaxRef.current.style.transform = `translateY(${scrollY * 0.35}px) scale(1.05)`;
      }
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleScroll = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="hero" id="hero">
      {/* Background */}
      <div className="hero-bg-wrap">
        <div
          className="hero-bg"
          ref={parallaxRef}
          style={{
            backgroundImage: `url(https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=1800&auto=format&fit=crop&q=80)`,
          }}
        />
        <div className="hero-overlay" />
      </div>

      {/* Floating ornaments */}
      <div className="hero-ornament hero-ornament--tl" />
      <div className="hero-ornament hero-ornament--br" />

      {/* Content */}
      <div className="hero-content">
        <div className="hero-eyebrow">
          <span className="hero-line" />
          <span className="hero-eyebrow-text">Est. 2019 · Paris, France</span>
          <span className="hero-line" />
        </div>

        <h1 className="hero-title">
          <span className="hero-title-top">Where Every</span>
          <em className="hero-title-italic">Plate</em>
          <span className="hero-title-bot">is a Portrait</span>
        </h1>

        <p className="hero-subtitle">
          Avant-garde European cuisine in an atmosphere<br />
          as carefully composed as the food itself.
        </p>

        <div className="hero-ctas">
          <button className="btn-gold" onClick={() => handleScroll('#menu')}>
            <span>Explore the Menu</span>
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path d="M1 7h12M7 1l6 6-6 6" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
          <button className="hero-btn-ghost" onClick={() => handleScroll('#contact')}>
            Reserve a Table
          </button>
        </div>

        <div className="hero-stats">
          {[
            { num: '18', label: 'Signature Dishes' },
            { num: '2', label: 'Michelin Stars' },
            { num: '400+', label: 'Wine Labels' },
          ].map((s) => (
            <div key={s.label} className="hero-stat">
              <span className="hero-stat-num">{s.num}</span>
              <span className="hero-stat-label">{s.label}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="hero-scroll-hint">
        <span>Scroll</span>
        <div className="hero-scroll-line" />
      </div>
    </section>
  );
}
